module.exports = __webpack_public_path__ + "img/组 126@2x(1).f4128a0f.png";